module.exports = __webpack_public_path__ + "static/media/SantaClara.c19d1961.png";